import React from 'react';
import { GrChatOption, GrClose } from 'react-icons/gr';
import styles from './QnAWidget.module.scss';

interface QnAWidgetIconProps {
  onClick: () => void;
}

export function QnAWidgetIcon({ onClick }: QnAWidgetIconProps) {
  return (
    <button className={styles.widgetIcon} onClick={onClick} type="button">
      <span className={`${styles.icon} ${styles.chat}`}>
        <GrChatOption size={24} />
      </span>
      <span className={`${styles.icon} ${styles.close}`}>
        <GrClose size={24} />
      </span>
    </button>
  );
}
